import $ from "jquery";

const mockData = [
    { title: "Test Link 1", url: "/" },
    { title: "Test Link 2", url: "/" },
    { title: "Test Link 3", url: "/" },
];
function QuestionBlock() {
    
    $('section[data-block-name]').each(function () {
        const section = $(this);
        const blockName = section.data('block-name');
        const inputId = `#id-${blockName}`;
        const resultsListId = `#result-${blockName}`;
        const resultsList = $(resultsListId);

        resultsList.hide();
        $(inputId).on('keyup', function () {
            const query = $(this).val().toLowerCase();
            resultsList.hide();
            resultsList.empty();

            if (!query) {
                resultsList.hide();
                return;
            }

            const filteredResults = mockData.filter(item =>
                item.title.toLowerCase().includes(query)
            );

            if (filteredResults.length > 0) {
                resultsList.show();
                filteredResults.forEach(item => {
                    resultsList.append(
                        `<a class="list-group-item text-decoration-none" href="${item.url}" target="_blank">${item.title}</a>`
                    );
                });
            }
        });
    });
}

export default QuestionBlock;